import * as React from "react";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled, { css } from "styled-components";
import { projectConfig } from "../../../../config/language/ja-JP/domain/model_text";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../../config/styles_const/styles_const";
import {
  Occupation,
  PaymentRange,
  Project,
  Status,
  WorkingHourRange,
} from "../../../../domain/model/project";
import Paragraph from "../../atom/text/paragraph";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  project: Project;
  onCopy: (id: string) => void;
}

const ProjectClientCard: React.FC<IProps> = (props) => {
  const { project } = props;

  const projectThumbnailURL: string = project.getThumbnailURL();
  const paymentRange: PaymentRange = project.paymentRange;
  const workingHourRange: WorkingHourRange = project.workingHourRange;
  const occupations: Occupation[] = project.occupations;
  const projectName: string = project.name;
  const projectId: string = project.id;
  const projectStatus: Status = project.status;
  const isOccupations: boolean = occupations.length !== 0;

  return (
    <Wrapper>
      <Area area={"projectThumbnail"}>
        <ProjectThumbnailWrapper>
          <ProjectThumbnail src={projectThumbnailURL} />
          <ProjectStatus status={projectStatus}>
            <ProjectStatusText bold={true}>
              {projectConfig.statusList[projectStatus]}
            </ProjectStatusText>
          </ProjectStatus>
        </ProjectThumbnailWrapper>
      </Area>
      <AreaExpand area={`projectName`}>
        <ProjectName bold={true}>{projectName}</ProjectName>
      </AreaExpand>
      {/* <Area area={`paymentRange`}>
        <ProjectInfoString>
          <ProjectInfoTitle>報酬/月</ProjectInfoTitle>
          <ProjectInfoBody bold={true}>
            {projectConfig.paymentRangeList[paymentRange]}
          </ProjectInfoBody>
        </ProjectInfoString>
      </Area>
      <Area area={`workingHourRange`}>
        <ProjectInfoString>
          <ProjectInfoTitle>報酬/月</ProjectInfoTitle>
          <ProjectInfoBody bold={true}>
            {projectConfig.workingHourRangeList[workingHourRange]}
          </ProjectInfoBody>
        </ProjectInfoString>
      </Area>
      <Area area={`occupations`}>
        {isOccupations && (
          <OccupationBadgeWrapper>
            {occupations.map((occupation) => {
              return (
                <BadgeBorder key={occupation}>
                  {projectConfig.occupationList.get(occupation)}
                </BadgeBorder>
              );
            })}
          </OccupationBadgeWrapper>
        )}
      </Area> */}
      <Area area={`buttons`}>
        <BtnLinkWrapper>
          <EditLink
            to=""
            onClick={(e) => {
              e.preventDefault();
              props.onCopy(projectId);
            }}
          >
            複製する
          </EditLink>
          <EditLink to={`/client/project/modify/${projectId}`}>
            編集する
          </EditLink>
          <PreviewLink to={`/client/project/preview/${projectId}`}>
            プレビュー
          </PreviewLink>
          <EntryLink to={`/client/entry/${projectId}`}>マッチング</EntryLink>
          <Budge>{project.messageRoomNum}</Budge>
        </BtnLinkWrapper>
      </Area>
    </Wrapper>
  );
};

export default ProjectClientCard;

const templateSP = `
    " occupations      occupations occupations      "
    " ...              ...         ...              "
    " projectThumbnail ...         ...              "
    " projectThumbnail ...         paymentRange     "
    " projectThumbnail ...         ...              "
    " projectThumbnail ...         workingHourRange "
    " projectThumbnail ...         ...              "
    " ...              ...         ...              "
    " projectName      projectName projectName      "
    " buttons          buttons     buttons          "
`;

const template = `
    "projectThumbnail ... projectName ...     paymentRange ...     workingHourRange "
    "projectThumbnail ... ...         ...     ...          ...     ...              "
    "projectThumbnail ... occupations ...     buttons      buttons buttons          "
`;

const Wrapper = styled.div`
  position: relative;
  padding: 10px;
  width: 100%;
  border-bottom: 1px solid ${ConstColor.PlaceholderAndBorder};
  background-color: ${ConstColor.White};

  // display: grid;
  // grid-template-areas: ${templateSP};
  // grid-template-columns: auto 10px 1fr;
  // grid-template-rows: auto 5px 20px auto 5px auto 20px 10px auto auto;
  // grid-column-gap: 0;
  // grid-row-gap: 0;
  // justify-content: center;

  // @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
  //   display: grid;
  //   grid-template-areas: ${template};
  //   grid-template-columns: auto 10px 1fr 15px auto 20px auto;
  //   grid-template-rows: auto 1fr auto;
  //   grid-column-gap: 0;
  //   grid-row-gap: 0;
  //   justify-content: center;
  // }

  display: flex;
`;

const ProjectThumbnailWrapper = styled.div`
  position: relative;
  margin-right: 10px;
`;

const ProjectThumbnail = styled.img`
  width: 100px;
  height: 50px;
  border-radius: ${ConstBorderRound.CornerRoundLeftTopLeftBottom};
  object-fit: cover;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    width: 100px;
    height: 50px;
  }
`;

const ProjectName = styled(Paragraph)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 15px important!;
`;

const ProjectInfoString = styled.div`
  display: flex;
  align-items: center;
`;

const ProjectInfoTitle = styled(ParagraphSup)`
  margin-right: 10px;
`;

const ProjectInfoBody = styled(Paragraph)``;

const ProjectStatus = styled.div<{ status: Status }>`
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  ${(props) =>
    props.status === Status.Status_Open &&
    css`
      background: ${ConstColor.Success};
    `}
  ${(props) =>
    props.status === Status.Status_OnlyScout &&
    css`
      background: ${ConstColor.Success};
    `}
  ${(props) =>
    props.status === Status.Status_Close &&
    css`
      background: ${ConstColor.Base};
    `} 
    ${(props) =>
    props.status === Status.Status_Contracted &&
    css`
      background: ${ConstColor.Base};
    `} 
    ${(props) =>
    props.status === Status.Status_Draft &&
    css`
      background: ${ConstColor.Focus};
    `}
`;

const ProjectStatusText = styled(ParagraphSup)`
  font-size: 8px !important;
  color: ${ConstColor.White};
`;

const Area = styled.div<{ area: string }>`
  // grid-area: ${(props) => props.area};
  // display: grid;
  align-items: center;
  height: 50px;
`;

const AreaExpand = styled.div<{ area: string }>`
  // grid-area: ${(props) => props.area};
  // display: grid;
  align-items: center;
  flex-grow: 1;
  height: 50px;
`;

const OccupationBadgeWrapper = styled.div``;

const BtnLinkWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 450px;
  height: 50px;
  flex-wrap: wrap;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    justify-content: flex-end;
  }
`;

const EditLink = styled(GoldLink)`
  // width: 100px;
  margin-right: 10px;
  margin-top: 10px;
  margin-right: 10px;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    margin-top: 0;
  }
`;

const PreviewLink = styled(GoldLink)`
  // width: 100px;
  margin-right: 10px;
  margin-top: 10px;
  margin-right: 10px;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    margin-top: 0;
  }
`;

const EntryLink = styled(GoldLink)`
  // width: 100px;
  margin-top: 10px;
  margin-right: 5px;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    margin-top: 0;
  }
`;

const Budge = styled.div`
  width: 20px;
  height: 20px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  border-radius: 10px;
  background-color: #9a8c64;
  text-align: center;
  line-height: 20px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/card/project_client_card.tsx